import { dateformat } from "../project/dateFormat";
import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";
import {
  FILE_DETAIL_FILTER_QUERY_KEYS,
  normalizeFileDetailFilters,
  serializeFileDetailFilterValues,
} from "lib/utils/fileDetailFilters";

export async function getFile(
  project_id,
  upload_id,
  user_id,
  sortKey = "",
  sortDir = "",
  locale = "",
  detailFilters = {},
) {
  if (!project_id || !upload_id || !user_id) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: "Required file query parameters are missing." },
        "Required file query parameters are missing.",
      ),
    };
  }

  try {
    const qs = new URLSearchParams();
    if (sortKey) qs.set("sortKey", sortKey);
    if (sortDir) qs.set("sortDir", sortDir);
    if (locale) qs.set("locale", locale);

    const normalizedDetailFilters = normalizeFileDetailFilters(detailFilters);
    Object.entries(FILE_DETAIL_FILTER_QUERY_KEYS).forEach(
      ([filterKey, queryKey]) => {
        const value = serializeFileDetailFilterValues(
          normalizedDetailFilters[filterKey],
        );
        if (value) qs.set(queryKey, value);
      },
    );

    const path =
      `${BACKEND_URL}/project/${project_id}/get_file/${upload_id}` +
      (qs.toString() ? `?${qs.toString()}` : "");

    const res = await authFetch(
      path,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (res.status === 401) {
      return {
        success: false,
        ...normalizeApiMessage(
          { message: "Session expired. Please sign in again." },
          "Session expired. Please sign in again.",
        ),
        messageKey: "api.auth.token.expired",
      };
    }

    const result = await res.json().catch(() => null);
    if (!result) {
      return {
        success: false,
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
      };
    }

    if (!res.ok || !result?.success) {
      return {
        success: false,
        ...normalizeApiMessage(result, "Failed to load file."),
      };
    }

    const rawFile = result.data;
    const prevFile = result.prev_file || null;
    const nextFile = result.next_file || null;
    const parsedFile = {
      ...rawFile,
      uploaded_at: rawFile?.uploaded_at
        ? dateformat(rawFile.uploaded_at).hasTimeDate
        : rawFile?.uploaded_at,
      clean_file_name: rawFile?.file_name ? rawFile.file_name.split(".")[0] : "",
    };

    return {
      success: true,
      ...normalizeApiMessage(result, "File loaded successfully."),
      data: parsedFile,
      prevFile,
      nextFile,
    };
  } catch (error) {
    console.error("getFile request failed:", error);
    return {
      success: false,
      ...normalizeApiMessage(
        { message: "Server request failed." },
        "Server request failed.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
